/**

  @name EmptySearchResults
  @description Category strip containing all search categories (Features, Design, Products, Ambasssadors etc)
@class

  @author Srinaath Ravichandran <sravichandran@deloitte.com>

  * @example
  * // client/index.js
  * ReactDOM.render(
  *   <EmptySearchResults serchTerm={searcgTerm}/>
  * )

*/

import React from "react";

import PropTypes from "prop-types";
import { find } from "lodash";
import { withNavContext } from "@lululemon/meganav-shared";
import LinkGenerator from "@lululemon/ecom-common/src/lib/link-generator";
import cs from "classnames";
import { parseFooterData } from "../../lib/nav-utils";
import styles from "./empty-search-result.module.scss";

class EmptySearchResults extends React.Component {
  constructor(props) {
    super(props);

    const { footer } = this.props;
    if (!footer) return;
    const { footerLinkGroups } = footer.fields;
    const footerLinks = parseFooterData(footerLinkGroups);
    // TODO: Replace this with JS Find Function
    const liveChatUrl = find(
      footerLinks,
      (dt) => dt.label.toLowerCase() === "live chat"
    );
    this.state = {
      liveChatLink: liveChatUrl?.url ?? "",
    };
  }

  render() {
    const placeHolder = process.browser
      ? window.location.search.split("=")[1]
      : "";
    const { searchTerm, bopis } = this.props;
    /* For tests */
    const liveChatLink = this.state?.liveChatLink;

    let errorText = `Sorry, no results were found for ${searchTerm}.`;

    if (!searchTerm) {
      errorText = `Sorry, no results were found for ${placeHolder}.`;
    }

    return (
      <div className={styles.emptySearchResults}>
        <div className={styles.container}>
          <div className="row">
            <div className="col-xs-12">
              <p className={`${styles.primaryError} OneLinkTx`}>{errorText}</p>
            </div>
            <div className="col-xs-12 col-sm-5">
              <p className={`${styles.helpText} OneLinkTx`}>
                Search Suggestions
              </p>
              <ul className={styles.suggestions}>
                {bopis ? (
                  <li
                    className={cs(
                      styles.bopisAllItems,
                      styles.suggestionsItem,
                      "OneLinkTx"
                    )}
                    onClick={this.props.showAllProducts}
                  >
                    Search all items
                  </li>
                ) : null}
                <li className={`${styles.suggestionsItem} OneLinkTx`}>
                  Try another search
                </li>
                <li className={`${styles.suggestionsItem} OneLinkTx`}>
                  Check your spelling
                </li>
                <li className={`${styles.suggestionsItem} OneLinkTx`}>
                  Try more general words
                </li>
                <li className={`${styles.suggestionsItem} OneLinkTx`}>
                  You can always narrow your search results later
                </li>
              </ul>
            </div>
            <div className="col-xs-12 col-sm-5">
              <div className={styles.helpSection}>
                <p className={`${styles.helpText} OneLinkTx`}>Let us help</p>
                <ul>
                  <li>
                    {liveChatLink && (
                      <LinkGenerator
                        href={liveChatLink}
                        className={styles.liveChat}
                      >
                        <span className="OneLinkTx">{" Live Chat"}</span>
                      </LinkGenerator>
                    )}
                    <span className="OneLinkTx">with an educator</span>
                  </li>
                  <li>
                    <span>1-877-263-9300</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

EmptySearchResults.propTypes = {
  footer: PropTypes.object,
  searchTerm: PropTypes.string,
  helpText: PropTypes.string,
};

export default withNavContext(EmptySearchResults);
